import React, { ReactNode } from "react"

import { AlertLevel } from "~tailwindui/types/enums"

import {
  alertBackgroundClassNames,
  alertIcon,
  alertTextClassNames,
} from "~tailwindui/helpers/classNameHelpers"

import classNames from "src/classNames"

export type AlertMessageBoxProps = {
  children: ReactNode
  level?: AlertLevel
  className?: string
}

const AlertMessageBox: React.FC<AlertMessageBoxProps> = ({
  children,
  level = AlertLevel.Error,
  className = "",
}) => {
  return (
    <div
      className={classNames(
        className,
        "rounded-md",
        alertBackgroundClassNames(level),
        "my-2 p-4"
      )}
    >
      <div className="flex">
        <div className="flex-shrink-0">{alertIcon(level)}</div>

        <div className="ml-3">
          <div
            className={classNames(
              "wrap-break-word text-sm font-medium",
              alertTextClassNames(level)
            )}
          >
            {children}
          </div>
        </div>
      </div>
    </div>
  )
}

export default AlertMessageBox
